<div [ngClass]="{ open: isAccordionOpen, 'accordion-child': isChild }" class="side-summary">
  <div *ngIf="!isChild" class="accordion-title">
    <h2 uni-heading alignText="center" weight="semibold" color="primary">{{ title }}</h2>
    <button type="button" (click)="toogleMobileAccordion()" size="lg" uni-icon-button variant="muted">
      <uni-icon size="xxl" name="x"></uni-icon>
    </button>
  </div>
  <accordion [isAnimated]="true" [ngClass]="{ 'dotted-box': !isChild }" [closeOthers]="closeOthers">
    <ng-container *ngFor="let group of groups">
      <accordion-group (isOpenChange)="group.onExpand($event)" [(isOpen)]="group.isExpanded" [ngClass]="{ isChild: isChild }">
        <div accordion-heading>
          <ng-container [ngTemplateOutlet]="group.title"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="group.content"></ng-container>
      </accordion-group>
    </ng-container>
  </accordion>
</div>

<button type="button" *ngIf="!isChild" (click)="toogleMobileAccordion()" class="accordion-mobile-container text-info">
  <button type="button" size="lg" uni-icon-button variant="info">
    <uni-icon size="lg" [name]="isAccordionOpen ? 'arrow-down-circle' : 'arrow-up-circle'"></uni-icon>
  </button>
  {{ isAccordionOpen ? openedText : closedText }}
</button>
